<template>
  <div class="app">
    <EpkIconsSprite style="position: absolute; width: 0; height: 0" />
    <Loader is-global />
    <transition-group
      name="toast-notification"
      tag="div"
      class="toast-notifications"
      @before-enter="stopBodyOverflow"
      @after-enter="allowBodyOverflow"
      @before-leave="stopBodyOverflow"
      @after-leave="allowBodyOverflow"
    >
      <ToastNotification
        v-for="item in notifications"
        :id="item.id"
        :key="item.id"
        :details="item.details"
        :size="item.size"
        :type="item.type"
        :message="item.message"
        :auto-close="item.autoClose"
        :duration="item.duration"
        @close="
          () => {
            removeNotifications(item.id);
          }
        "
      />
    </transition-group>

    <SystemAnnouncementPopup />

    <!-- Auth -->
    <EsiaAuthBoundary
      v-if="isAuthEnabled"
      :base-get="baseGet"
      :keycloak="keycloak"
      :notify-error="notifyError"
    >
      <AccessBoundary>
        <router-view />
      </AccessBoundary>
    </EsiaAuthBoundary>
    <AccessBoundary v-else>
      <router-view />
    </AccessBoundary>
  </div>
</template>

<script setup lang="ts">
import { KeycloakAdapter } from 'keycloak-js';
import { inject } from 'vue';
import { Loader, ToastNotification } from '~packages/epk-front-shared/ui';
import { EsiaAuthBoundary } from '~packages/esia-auth-boundary';

import getConstants from '@/shared/constants';
import { useNotificationStore } from '@/shared/model';
import { baseGet } from '@/utils/useKeycloakAdapterEsia';
import { AccessBoundary } from '@/widgets/access-boundary';
import { SystemAnnouncementPopup } from '@/widgets/system-announcement';
import EpkIconsSprite from '@epk/icons/epk-icons.svg?component';

const keycloak = inject('keycloak') as KeycloakAdapter;

const { isAuthEnabled } = getConstants();

const {
  notifications,
  notifyError,
  removeNotifications,
  stopBodyOverflow,
  allowBodyOverflow,
} = useNotificationStore();
</script>

<style lang="scss" scoped src="./style.scss" />
